const LightThemeColors = [
  {
    name: 'CRIMSON_RED',
    palette: {
      primary: {
        50: '#FFF2F2', // primary.w10
        100: '#FFCCCC', // primary.w8
        200: '#FF9999', // primary.w6
        300: '#FF6666', // primary.w4
        400: '#FF3333', // primary.w2
        500: '#FF0000', // primary
        600: '#CC0000', // primary.b2
        700: '#990000', // primary.b4
        800: '#660000', // primary.b6
        900: '#330000', // primary.b10
        main: '#B30000', // primary.b3
        light: '#FFE6E6', // primary.w9
        dark: '#660000', // primary.b6
        contrastText: '#FFFFFF', // based on YIQ contrast
      },
      secondary: {
        50: '#F4F8FC', // secondary.w10
        100: '#D3E2F3', // secondary.w8
        200: '#A7C5E7', // secondary.w6
        300: '#7BA8DB', // secondary.w4
        400: '#4F8BCF', // secondary.w2
        500: '#236EC3', // secondary
        600: '#1C589C', // secondary.b2
        700: '#154275', // secondary.b4
        800: '#0E2C4E', // secondary.b6
        900: '#071627', // secondary.b10
        main: '#236EC3', // secondary
        light: '#E9F1F9', // secondary.w9
        dark: '#0E2C4E', // secondary.b6
        contrastText: '#FFFFFF', // based on YIQ contrast
      },
    },
  },
  {
    name: 'CELTIC_BLUE',
    palette: {
      primary: {
        50: '#F4F8FC', // secondary.w10
        100: '#D3E2F3', // secondary.w8
        200: '#A7C5E7', // secondary.w6
        300: '#7BA8DB', // secondary.w4
        400: '#4F8BCF', // secondary.w2
        500: '#236EC3', // secondary
        600: '#1C589C', // secondary.b2
        700: '#154275', // secondary.b4
        800: '#0E2C4E', // secondary.b6
        900: '#071627', // secondary.b10
        main: '#236EC3', // secondary
        light: '#E9F1F9', // secondary.w9
        dark: '#0E2C4E', // secondary.b6
        contrastText: '#FFFFFF', // based on YIQ contrast
      },
      secondary: {
        50: '#FFF2F2', // primary.w10
        100: '#FFCCCC', // primary.w8
        200: '#FF9999', // primary.w6
        300: '#FF6666', // primary.w4
        400: '#FF3333', // primary.w2
        500: '#FF0000', // primary
        600: '#CC0000', // primary.b2
        700: '#990000', // primary.b4
        800: '#660000', // primary.b6
        900: '#330000', // primary.b10
        main: '#B30000', // primary.b3
        light: '#FFE6E6', // primary.w9
        dark: '#660000', // primary.b6
        contrastText: '#FFFFFF', // based on YIQ contrast
      },
    },
  },
  {
    name: 'PIGMENT_GREEN',
    palette: {
      primary: {
        50: '#F2FAF5', // tertiary.w10
        100: '#CDECD6', // tertiary.w8
        200: '#9AD9AD', // tertiary.w6
        300: '#68C684', // tertiary.w4
        400: '#35B35B', // tertiary.w2
        500: '#03A032', // tertiary
        600: '#028028', // tertiary.b2
        700: '#02601E', // tertiary.b4
        800: '#014014', // tertiary.b6
        900: '#01200A', // tertiary.b10
        main: '#027023', // tertiary.b3
        light: '#E6F6EB', // tertiary.w9
        dark: '#014014', // tertiary.b6
        contrastText: '#FFFFFF', // based on YIQ contrast
      },
      secondary: {
        50: '#FFF2F2', // primary.w10
        100: '#FFCCCC', // primary.w8
        200: '#FF9999', // primary.w6
        300: '#FF6666', // primary.w4
        400: '#FF3333', // primary.w2
        500: '#FF0000', // primary
        600: '#CC0000', // primary.b2
        700: '#990000', // primary.b4
        800: '#660000', // primary.b6
        900: '#330000', // primary.b10
        main: '#B30000', // primary.b3
        light: '#FFE6E6', // primary.w9
        dark: '#660000', // primary.b6
        contrastText: '#FFFFFF', // based on YIQ contrast
      },
    },
  },
  {
    name: 'NANG',
    palette: {
      primary: {
        main: '#00857D',
        light: '#d7ecea',
        // dark: '#00716a',
        contrastText: '#ffffff'
      },
      secondary: {
        main: '#330000',
        // light: '#eea75b',
        // dark: '#5a0000',
        contrastText: '#ffffff'
      },
      error: {
        main: '#DF2901',
        // light: '#991C00',
        // dark: '#E9694D',
        contrastText: '#ffffff'
      },
      warning: {
        main: '#FBD300',
        // light: '#DFFC30',
        // dark: '#615100',
        contrastText: '#121212'
      },
      info: {
        main: '#2196f3',
        // light: '#64b5f6',
        // dark: '#1976d2',
        contrastText: '#fff'
      },
      success: {
        main: '#29A855',
        // light: '#2CB55C',
        // dark: '#10602C',
        contrastText: '#ffffff'
      },
      text: {
        primary: '#121212',
        secondary: '#5F5753',
        disabled: 'rgba(36, 36, 36, 0.38)',
        hint: 'rgba(36, 36, 36, 0.38)',
        navSecondary: '#121212',
        navActive: '#121212',
        textSecondary: '#121212',
        textActive: '#121212',
        error: '#C91A13',
        success: '#29A855',
        gray900: '#1C1D21CC',
        tooltip: '#1C1D21',
        cngBlack: '#1C1D21',
        widgetTitle: '#1c1d21',
        widgetSubTitle: '#7680a3',
        base: '#121212'
      }
    },
  }
];

export { LightThemeColors };
